import { useAuth0 } from "@auth0/auth0-react";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Action from "components/ActionPopOver";
import Loader from "components/loader/Loader";
import Spinner from "components/spinner";
import { formatDate } from "helper";
import AuthService from "Lib/API/Auth";
import FinanceService from "Lib/API/Finance";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { appContext } from "Router/routes";
import thousands from "thousands";
import { CheckFloatValue } from "../../../utils/functions";
import FinanceList from "./FinanceList";
import "./index.scss";
import MembersList from "./MembersList";
import Notes from "./Notes";

const AccountsDrawer = ({
  account,
  accountId,
  setOpenAlert,
  onMergeClick,
  setAccountById,
  ...props
}) => {
  const [selected, setSelected] = useState("members");
  const [notes, setNotes] = useState([]);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const { setTypeUser } = React.useContext(appContext);

  const history = useHistory();

  React.useEffect(() => {
    setAccountById(account);
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getInvoices(
        { filter: { account_id: accountId } },
        0,
        10000,
        token
      )
        .then((res) => {
          if (res?.invoices) {
            setInvoices(res.invoices);
            setLoading(false);
          } else setInvoices([]);
        })
        .catch((err) => {
          // toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }, []);

  React.useEffect(() => {
    async function fetchMyAPI() {
      setLoading(true);
      const token = await getAccessTokenSilently();
      AuthService.getNotesByAccountId(accountId, token)
        .then((res) => {
          setLoading(false);
          setNotes(Array.isArray(res) ? res : []);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
          setLoading(false);
        });
    }
    fetchMyAPI();
  }, [refresh]);
  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      AuthService.getAccountById(accountId, token)
        .then((res) => {
          if (res) {
            setFamilyMembers(res[0]?.family_members);
          }
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }, [refresh]);

  const handleAddNote = async (note, tags = []) => {
    const token = await getAccessTokenSilently();
    const data = {
      account_id: accountId,
      note: note,
      tags,
    };
    AuthService.createNote(data, token)
      .then((res) => {
        if (res) {
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const handleDeleteNote = async (id) => {
    const token = await getAccessTokenSilently();
    await AuthService.removeNote(
      {
        noteIds: [`${id}`],
      },
      token
    )
      .then((res) => {
        if (res) {
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const calculateBalance = (numOne, numTwo) => {
    if (numOne === 0) {
      return numTwo;
    } else {
      return numOne - numTwo;
    }
  };

  const balance = thousands(
    calculateBalance(
      account?.payment?.wallet?.balance ? account?.payment?.wallet?.balance : 0,
      account?.payment?.balance ? account?.payment?.balance : 0
    ).toFixed(2)
  );

  const TabContent = () => {
    switch (selected) {
      case "members":
        return (
          <MembersList
            family_members={familyMembers}
            refresh={refresh}
            setRefresh={setRefresh}
            mainContactId={account?.main_contact?._id}
          />
        );
      case "finance":
        return <FinanceList invoices={invoices} account={account} />;
      case "notes":
        return (
          <Notes
            notes={notes}
            handleAdd={handleAddNote}
            handleDelete={handleDeleteNote}
            refresh={refresh}
            setRefresh={setRefresh}
            loading={loading}
            setLoading={setLoading}
          />
        );
      default:
        return (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </div>
        );
    }
  };

  return (
    <div className="account-drawer">
      <>
        <div className="account-drawer-header p-5">
          <div className="account-header">
            <div
              className="name"
              onClick={() => {
                setTypeUser(false);
                history.push(`/member-details/${account._id}`);
              }}
            >
              <span className="cursor-pointer">{`${account?.family_name}`}</span>
            </div>
            <div className="cursor-pointer">
              <Action
                onEditClick={() => {
                  setTypeUser(false);
                  history.push(`/member-details/${account._id}`);
                }}
                onActiveClick={() => {}}
                onDeleteClick={() => setOpenAlert(true)}
                onMergeClick={onMergeClick}
                checkActive={true}
                style={{
                  color: "#3f4255",
                  width: "16px",
                  height: "16px",
                }}
              />
            </div>
          </div>
          <div className="account-id py-5">#{account?.account_id}</div>
          <div className="account-creation-date account-badge">
            Created date{" "}
            {formatDate({
              date: account?.createdAt,
              formatType: "defaultWithUTC",
            })}
          </div>
          <div className="account-badge py-5">
            <span className="mr-2">
              <AccountCircleIcon
                style={{ alignSelf: "center", marginRight: "5px" }}
              />
              {account?.payment?.account_sub_type?.title}
            </span>
          </div>
        </div>
        <hr />
        <div className="account-drawer-content">
          <div className="account-drawer-tabs">
            <div className="toggle-bar">
              <p
                className={selected === "members" ? "selected" : "unselected"}
                onClick={() => setSelected("members")}
              >
                <span className="title">Members</span>
              </p>
              <p
                className={selected === "finance" ? "selected" : "unselected"}
                onClick={() => setSelected("finance")}
              >
                <span className="title">Finance</span>
              </p>
              <p
                className={selected === "notes" ? "selected" : "unselected"}
                onClick={() => setSelected("notes")}
              >
                <span className="title">Notes</span>
              </p>
            </div>
          </div>
          <div className="tab-content p-5">
            <TabContent />
          </div>
        </div>
      </>
    </div>
  );
};

export default AccountsDrawer;
